import makeRequest from "../api/makeRequest";
import url from "../api/urls";

export class PaymentService {
    static async createOrder(examId: string) {
        return await makeRequest(url.payment.createOrder + "/" + examId, "POST");
    }

    static async verifyPayment(payload: {
        razorpay_payment_id: string;
        razorpay_order_id: string;
        razorpay_signature: string;
    }) {
        return await makeRequest(url.payment.verifyPayment, "POST", payload);
    }

    static async getExamDetails(examId: string) {
        return await makeRequest(url.payment.getExamDetails + "/" + examId, "GET");
    }

    static async createGroupPaymentOrder(groupId: string) {
        return await makeRequest(url.examGroup.payGroup + "/" + groupId, "POST");
    }

    static async verifyGroupPayment(payload: {
        razorpay_payment_id: string;
        razorpay_order_id: string;
        razorpay_signature: string;
    }) {
        return await makeRequest(url.examGroup.verifyGroupPayment, "POST", payload);
    }

    static async requestManualPayment(groupId: string, payload: {
        paymentProof: string;
        paymentProofName: string;
    }) {
        return await makeRequest(url.examGroup.manualPaymentRequest + "/" + groupId, "POST", payload);
    }
}